
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/latihan",
      function () {
        return require("private-next-pages/latihan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/latihan"])
      });
    }
  